import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ServerTimeService {
  private sTime: moment.Moment;
  private sLocal: moment.Moment;
  private diff: number;

  constructor() { }

  set(stime: string) {
    this.sTime = moment(stime);
    this.sLocal = moment();
    this.diff = this.sLocal.diff(this.sTime, 'seconds');
  }

  guessServerTime(): moment.Moment {
    const base = moment().subtract(this.diff, 'seconds');
    return base;
  }
}
